import React from "react";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <>
      <section
        id="home"
        className="relative flex items-center min-h-screen bg-[#0a1628] overflow-hidden pt-[70px]"
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.28),transparent_32%),radial-gradient(circle_at_85%_18%,rgba(96,165,250,0.16),transparent_24%),linear-gradient(180deg,#0a1628_0%,#091120_100%)]"></div>

        {/* Grid background */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:48px_48px]"></div>

        {/* Content */}
        <div className="relative z-10 w-full px-6 py-20">
          <div className="max-w-[1000px] mx-auto flex flex-col items-center">
            <motion.div
              initial={{ opacity: 0, y: 30, z: 0 }}
              animate={{ opacity: 1, y: 0, z: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              style={{ willChange: "transform, opacity" }}
              className="flex flex-col items-center text-center"
            >
              {/* Badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.9, z: 0 }}
                animate={{ opacity: 1, scale: 1, z: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                style={{ willChange: "transform, opacity" }}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-6
             bg-blue-600/15 border border-blue-500/40 text-blue-300"
              >
                🏭 ISO-Certified Label Manufacturer
              </motion.div>

              {/* Title */}
              <motion.h1
                initial={{ opacity: 0, y: 20, z: 0 }}
                animate={{ opacity: 1, y: 0, z: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                style={{ willChange: "transform, opacity" }}
                className="font-extrabold text-white leading-[1.1] mb-6 text-[36px] sm:text-[48px] md:text-[72px] text-center"
              >
                Custom Label <br />
                <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                  Printing in Surat, India
                </span>
              </motion.h1>

              {/* Subtitle */}
              <motion.p
                initial={{ opacity: 0, y: 20, z: 0 }}
                animate={{ opacity: 1, y: 0, z: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                style={{ willChange: "transform, opacity" }}
                className="text-white/70 text-[14px] sm:text-lg leading-relaxed mb-10 text-center max-w-[700px]"
              >
                Sahajink is a leading label printing company providing premium custom label printing solutions globally. From pharma to FMCG, we deliver precision labels at scale with international quality standards.
              </motion.p>

              {/* CTA */}
              <motion.div
                initial={{ opacity: 0, y: 20, z: 0 }}
                animate={{ opacity: 1, y: 0, z: 0 }}
                transition={{ duration: 0.8, delay: 0.5 }}
                style={{ willChange: "transform, opacity" }}
                className="flex flex-wrap justify-center gap-4 mb-14"
              >
                <a
                  href="#contact"
                  className="px-8 py-4 text-[12px] sm:text-[16px] rounded-full bg-blue-600 text-white font-bold uppercase tracking-wider hover:bg-blue-500 transition shadow-lg shadow-blue-600/20"
                >
                  Get a Free Quote
                </a>

                <a
                  href="#products"
                  className="px-8 py-4 text-[12px] sm:text-[16px] rounded-full border border-white/20 text-white font-bold uppercase tracking-wider hover:bg-white/10 transition backdrop-blur-sm"
                >
                  Explore Products
                </a>
              </motion.div>

              {/* Stats */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.6 }}
                className="flex flex-wrap items-center justify-center gap-8 md:gap-12"
              >
                <div className="flex flex-col">
                  <span className="text-3xl md:text-4xl font-black text-white">
                    10M+
                  </span>
                  <span className="text-blue-300/60 text-xs font-bold uppercase tracking-widest mt-2">
                    Labels Printed
                  </span>
                </div>

                <div className="hidden sm:block w-[1px] h-9 bg-white/10"></div>

                <div className="flex flex-col">
                  <span className="text-3xl md:text-4xl font-black text-white">
                    500+
                  </span>
                  <span className="text-blue-300/60 text-xs font-bold uppercase tracking-widest mt-2">
                    Happy Clients
                  </span>
                </div>

                <div className="hidden sm:block w-[1px] h-9 bg-white/10"></div>

                <div className="flex flex-col">
                  <span className="text-3xl md:text-4xl font-black text-white">
                    4+
                  </span>
                  <span className="text-blue-300/60 text-xs font-bold uppercase tracking-widest mt-2">
                    Years Experience
                  </span>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
